//
import { mapGetters } from 'vuex'

/**
 * { item_description }
 */
export default {
    computed: {
        ...mapGetters('AuthModule', {
            $can: 'can',
        }),
    },
}

/**
 * { lambda_description }
 *
 * @param      {Function}  permission  The permission
 * @return     {<type>}    { description_of_the_return_value }
 */
const beforeRouteEnter = permission => (to, from, next) => next(can(permission))

/**
 * { lambda_description }
 *
 * @param      {<type>}   permission  The permission
 * @return     {boolean}  { description_of_the_return_value }
 */
const can = permission => ctx => {
  if (!ctx.$can(permission)) ctx.$router.push('/')
}

//
export { beforeRouteEnter, can }